import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardHotelPWAv2/l10n";
import { useLocalization } from "@shared-ui/localization-context";
import { HotelWizardStateProps } from "../typings";
import { UitkTabs, UitkTab, UitkTabsType } from "uitk-react-tabs";

export const HotelTabs = observer((props: HotelWizardStateProps) => {
  const { formatText } = useLocalization();
  const tabHotelTitle = formatText(locKeys.hotelTitle);
  const tabVrTitle = formatText(locKeys.vrTitle);
  const hotelWizardState = props.hotelWizardState;
  const currentTab = hotelWizardState.hotelTabSelected ? tabHotelTitle : tabVrTitle;

  return (
    <UitkTabs tabsType={UitkTabsType.NATURAL} selectedTab={currentTab} onTabSelect={hotelWizardState.toggleTabSelected}>
      <UitkTab name={tabHotelTitle} />
      <UitkTab name={tabVrTitle} />
    </UitkTabs>
  );
});
